import { Navigate, useLocation } from "react-router-dom";
import { urls } from "../../../urls";

export const OrganizationsRoute = () => {
  const location = useLocation();
  return <Navigate to={`${urls.v2.organizations}${location.search}${location.hash}`} replace />;
};
